import { ListingFaq } from '@components/listing-faq/models';
import { Block } from '@shared/models';

export const listingFaqMock = (opts?: {
  excludeFaqWithName?: string;
  includeOnlyFaqWithIds?: string[];
  title?: string;
}): Block<ListingFaq> => ({
  type: 'listing-faq',
  data: {
    includeOnlyFaqWithIds: opts?.includeOnlyFaqWithIds,
    excludeFaqWithQuestion: opts?.excludeFaqWithName,
    title: opts?.title,
  },
});
